import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Counter.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b24-counter",class:_vm.classes},[_c('button',{staticClass:"b24-counter__button _minus",attrs:{"type":"button","disabled":_vm.value <= _vm.minValue || _vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onAction('minus')}}},[_vm._v("\n    −\n  ")]),_vm._v(" "),_c('label',{staticClass:"b24-counter__input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim.number",value:(_vm.value),expression:"value",modifiers:{"trim":true,"number":true}}],ref:"input",staticClass:"b24-counter__input-control",attrs:{"type":"tel","disabled":_vm.isDisabled},domProps:{"value":(_vm.value)},on:{"paste":function($event){$event.preventDefault();},"blur":[_vm.onBlur,function($event){return _vm.$forceUpdate()}],"keypress":_vm.valueMask,"input":[function($event){if($event.target.composing){ return; }_vm.value=_vm._n($event.target.value.trim());},function($event){$event.preventDefault();return _vm.onInput($event)}],"focus":_vm.onFocus,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onAction('plus')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onAction('minus')}]}})]),_vm._v(" "),_c('button',{staticClass:"b24-counter__button _plus",attrs:{"type":"button","disabled":_vm.value >= _vm.maxValue || _vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onAction('plus')}}},[_vm._v("\n    +\n  ")])])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
